// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ri-0";
export var leftAlign = "_ri-4";
export var listItem = "_ri-2";
export var listItemWrapper = "_ri-1";
export var operationText = "_ri-3";